import { EkycStatus } from '../../core/enum/ekyc-status.enum';
import { IdentificationType } from '../../core/enum/identification-type.enum';

// INC-289: the set of profile fields that constitute an "identity change" for
// re-KYC purposes. Kept as one canonical list so profile-details.component.ts
// (today) and the Phase-2 review-attest sheet (later) agree on exactly the
// same fields.
export const IDENTITY_FIELDS = ['fullName', 'identityNo', 'userIdentityNoType'] as const;

export interface IdentityComparable {
  fullName: string;
  identityNo: string;
  userIdentityNoType: IdentificationType;
}

// INC-259: a Verified investor changing name/IC/identity-type triggers re-KYC.
// The backend holds the change as pending and requires re-verification.
// Extracted verbatim from profile-details.component.ts's update() so both the
// standalone settings page and the review-attest edit sheet route into
// /proceed-e-kyc on the exact same condition.
export function detectIdentityChange(
  original: IdentityComparable,
  updated: IdentityComparable,
  ekycStatus: EkycStatus,
): boolean {
  return (
    ekycStatus == EkycStatus.Verified &&
    IDENTITY_FIELDS.some((field) => updated[field] != original[field])
  );
}
